/* eslint-disable react-refresh/only-export-components */
import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'

const ScreeningPage = lazy(() => import('./pages/list/ScreeningListPage'))
const ScreeningDetailPage = lazy(() => import('./pages/detail/ScreeningDetailPage'))

export const screeningRoutes: RouteObject[] = [
  {
    path: 'screening',
    element: <ScreeningPage />,
  },
  {
    path: '/screening/:screeningId',
    element: <ScreeningDetailPage/>,
  },
]
